// extracted by mini-css-extract-plugin
module.exports = {"skillsWithYears":"tagBlock_skillsWithYears__1yyPo","tagContainer":"tagBlock_tagContainer__2OIr-"};